import React from "react";

import { Button, Tag } from "clearsense-ui/components";
import PermissibleWrapper from "components/Common/PermissibleWrapper";

const getStatusColor = text => {
  switch (text) {
    case "Active":
      return "#EBF4EC";
    case "Inactive":
      return "#FAEAEA";
    default:
      return "";
  }
};

const getRuleName = text => {
  switch (text) {
    case "min_data_length":
      return "Minimum Length";
    case "max_data_length":
      return "Maximum Length";
    case "data_length":
      return "Exact Length";
    case "alphanumeric":
      return "Alphanumeric Only";
    case "numeric":
      return "Numeric Only";
    case "letters_only":
      return "Alphabets Only";
    case "null_not_possible":
      return "Null Values Possible";
    case "starts_with":
      return "Starts with";
    case "ends_with":
      return "Ends With";
    case "contains":
      return "Contains";
    default:
      return "Unknown Rule";
  }
};

const COLUMN_DATA = (
  setCurrentlyEditedId,
  setIsCreateRuleOpen,
  userPermissions
) => [
  {
    dataIndex: "title",
    key: "title",
    title: "Title",
    width: "20%",
  },
  {
    dataIndex: "name",
    key: "name",
    title: "Rule",
    width: "20%",
    render: text => getRuleName(text),
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    render: text => <div className="whitespace-pre-line">{text}</div>,
    width: "30%",
  },
  {
    dataIndex: "value",
    key: "value",
    title: "Value",
    width: "20%",
  },
  {
    dataIndex: "active",
    key: "active",
    title: "Status",
    width: "10%",
    render: text => (
      <Tag
        color={getStatusColor(text ? "Active" : "Inactive")}
        label={text ? "Active" : "Inactive"}
      />
    ),
  },
  {
    dataIndex: "action",
    key: "action",
    title: "Action",
    width: "10%",
    render: (_, record) => (
      <PermissibleWrapper
        currentPermissions={userPermissions}
        acceptablePermissions="update"
      >
        <Button
          style="secondary"
          label="Edit"
          onClick={() => {
            setCurrentlyEditedId(record.id), setIsCreateRuleOpen(true);
          }}
        />
      </PermissibleWrapper>
    ),
  },
];

export { COLUMN_DATA };
